import { MenuAlt2Icon } from '@heroicons/react/outline'
import LanguageSwitcher from 'components/atoms/LanguageSwitcher'
import useDocumentTitle from 'hooks/useDocumentTitle'
import { get } from 'lodash'
import { parseCookies } from 'nookies'
import { useSelector, useDispatch } from 'react-redux'
import { setDrawerToggle } from 'state/redux/actions/settings.actions'
import classNames from 'classnames'

const Header = ({ title = 'Admin Panel', toolbar, showLogo, headerRight, pages = [], border = true, showTitle = true }) => {
  const drawer = useSelector(state => get(state, 'settings.drawer'))
  const dispatch = useDispatch()
  const { scanner } = parseCookies()

  const scannerInterface = Boolean(scanner === 'true')

  const openDrawer = () => {
    dispatch(setDrawerToggle(!drawer))
  }

  const currentWorkspace = useSelector(state => get(state, 'user.workspace'))
  const user = useSelector(state => get(state, 'user.user'))

  useDocumentTitle(` ${title} | Ajarlee`)

  return (
    <>
      <div
        className={classNames(
          'relative top-0 md:min-h-[54px] bg-white px-4 py-0 sm:flex items-center sm:justify-between sm:px-6 sidebar:px-6',
          border && 'border-b border-gray-200'
        )}
      >
        <div className="flex sm:max-w-[20rem] md:max-w-full flex-nowrap shrink-0 mr-4">
          {!drawer && !(user.scanner && scannerInterface) && (
            <>
              <button onClick={openDrawer} className="mr-3">
                <MenuAlt2Icon className="h-5 w-5" aria-hidden="true" />
              </button>
              <LanguageSwitcher compact />
            </>
          )}
          <div className="flex items-center">
            {showLogo ? <img src={currentWorkspace?.logo} className="h-[30px] mr-4" alt="" /> : null}
            {/* eslint-disable-next-line */}
            {showTitle && title?.trim() ? <h1 className="flex-1 text-sm text-gray-900 font-medium mb-0 flex-nowrap">{title}</h1> : null}
          </div>
        </div>
        <div className="flex-1 flex items-center justify-end flex-wrap gap-2 min-w-0 overflow-visible">{headerRight}</div>
      </div>
    </>
  )
}

export default Header
